import { render, staticRenderFns } from "./analyse-smokecrib.vue?vue&type=template&id=2ef47f71&scoped=true&"
import script from "./analyse-smokecrib.vue?vue&type=script&lang=ts&"
export * from "./analyse-smokecrib.vue?vue&type=script&lang=ts&"
import style0 from "./analyse-smokecrib.vue?vue&type=style&index=0&id=2ef47f71&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ef47f71",
  null
  
)

export default component.exports